
const routes = {
  landing: '/',
  // application: '/application',
  // job: '/job',
  // success: '/success',
  privacy: '/privacy',
  faq: '/faq',
  terms: '/terms',
};

const contentRoutes = {
  // job: `${routes.job}/:id`,
  // application: `${routes.application}/:id`
};

export { contentRoutes };

export default routes;